<template>
  <v-list-item class="white rounded-lg">
    <v-list-item-content>
      <v-list-item-subtitle>Usuário selecionado</v-list-item-subtitle>
      <v-list-item-title class="title">{{
        usuarioLogado.usuario
      }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <trocar-usuario icon v-if="novopedido.produtos.length == 0" />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import TrocarUsuario from "@/components/usuario/TrocarUsuario.vue";
import { mapState } from "vuex";

export default {
  components: { TrocarUsuario },
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("pedidos", ["step", "novopedido"]),
  },
};
</script>

<style>
</style>